import { create } from 'zustand';
import { PrizeetAuthUser } from '../interface/interface';

interface OrderManagementStore {
  currentStep: number;
  onStepChange: (step: number) => void;
  action?:  'nextStep' | 'previousStep';
  authUser?: PrizeetAuthUser
}

let settings: OrderManagementStore = {
  currentStep: 0,
  action: null,
  authUser: null,
  onStepChange: (step: number) => {
    settings.currentStep = step;
  }
}

export interface OrderManagementState {
  settings: OrderManagementStore;
  actions: {
    setActiveStep: (step: number) => void;
    setActionCommand: (action: 'nextStep' | 'previousStep') => void;
    setAuthUser: (authUser: PrizeetAuthUser) => void;
  };
}

export const useOrderManagementStore = create<OrderManagementState>((set) => ({
  settings,
  actions: {
    setAuthUser(user: PrizeetAuthUser) {
      set((state) => ({
        settings: {
          ...state.settings,
          authUser: user,
        }
      }));
    },
    setActionCommand: (action: 'nextStep' | 'previousStep') => {
      set((state) => ({
        settings: {
          ...state.settings,
          action: action,
        }
      }));
    },
    setActiveStep: (step: number) => {
      set((state) => ({
        settings: {
          ...state.settings,
          currentStep: step,
        }
      }));
    },

  }
}));
